<script setup lang="ts">
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
    title?: string;
    initialState?: 'open' | 'closed';
    selected?: boolean;
}
const { title = '' } = defineProps<IProps>();
const modelValue = defineModel<boolean>({
    default: (props: IProps) => props.initialState !== 'closed',
});
const body = ref<HTMLDivElement>();
const maxHeight = ref<number>();
const toggle = () => {
    modelValue.value = !modelValue.value;
};
onMounted(() =>
    nextTick(() => {
        maxHeight.value = body.value?.clientHeight ?? undefined;
    })
);
</script>

<template>
    <div
        class="filter-part"
        :class="{ expanded: modelValue }"
        :style="{ '--max-height': `${maxHeight}px` }"
    >
        <div class="header" @click="toggle">
            <div class="title-container">
                <slot name="title">
                    <mr-typography
                        weight="700"
                        color="var(--blue-600)"
                        class="title"
                    >
                        {{ title }}
                    </mr-typography>
                </slot>
                <div v-if="selected" class="selected" />
            </div>
            <mr-icon
                :icon="faAngleDown"
                color="var(--cool-gray-800)"
                size="large"
                class="toggle-btn"
            />
        </div>
        <div class="filter-part-body">
            <div ref="body" class="body-wrapper">
                <slot />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.filter-part {
    position: relative;
    padding: 16px;
    @include mobile-only {
        padding: 8px 16px;
    }
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        cursor: pointer;
        margin-bottom: 8px;
        .title-container {
            display: flex;
            align-items: center;
            gap: 8px;
            .title {
                @include mobile-only {
                    margin: 0;
                }
            }
            .selected {
                background-color: usePalette();
                border-radius: 99999px;
                width: 10px;
                height: 10px;
            }
        }

        .toggle-btn {
            transition: transform 200ms;
        }
    }
    .filter-part-body {
        max-height: 0;
        transition: max-height 200ms;
        overflow: hidden;
    }
    &.expanded {
        .filter-part-body {
            max-height: var(--max-height, 600px);
            overflow: visible;
        }
        .toggle-btn {
            transform: rotate(180deg);
        }
    }
}
</style>
